import { Component } from "react";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import InvoiceReport from "./InvoiceReport/InvoiceReport";
import InvoiceStatistics from "./InvoiceStatistics/InvoiceStatistics";
import { PrimaryArrowButton } from "components/button/Button";
import { emptyCommitments, setAssignmentManagerList } from "../Actions";
import OfficeList from "./OfficeList/OfficeList";
import { fetchOffices, getAssignmentManagerList } from "../Services";

class Invoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOffice: null
    };
  }

  componentDidMount() {
    this.props.dispatch(fetchOffices());
  }

  resetSelectedOffice() {
    this.props.dispatch(emptyCommitments());
    this.props.dispatch(setAssignmentManagerList([]));
    this.setState({ selectedOffice: null });
  }

  setSelectedOffice(office) {
    this.setState({ selectedOffice: office });
    this.props.dispatch(getAssignmentManagerList(office));
  }

  render() {
    return (
      <div className={"box"}>
        <h1>Fakturering</h1>
        <hr className={"header-border"} />

        {!this.state.selectedOffice && (
          <OfficeList
            onSelectOffice={(office) => this.setSelectedOffice(office)}
          />
        )}

        {this.state.selectedOffice && (
          <>
            <div className={"d-flex justify-content-between mb-5"}>
              <h2 className={"m-0"}>{this.state.selectedOffice.name}</h2>
              <PrimaryArrowButton
                onClick={() => {
                  this.resetSelectedOffice();
                }}
              >
                Byt marknadsområde
              </PrimaryArrowButton>
            </div>

            <Tabs>
              <TabList>
                <Tab>Fakturarapport</Tab>
                <Tab>Statistik</Tab>
              </TabList>
              <TabPanel>
                <InvoiceReport selectedOffice={this.state.selectedOffice} />
              </TabPanel>
              <TabPanel>
                <InvoiceStatistics selectedOffice={this.state.selectedOffice} />
              </TabPanel>
            </Tabs>
          </>
        )}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    mode: state.invoices.mode,
    selectedOffice: state.invoices.selectedOffice
  };
})(Invoices);
